import { log } from "../../../../helpers/logger"
import type { AmplitudeWebPlugin } from "../../types"

export const LoggerIntegration: AmplitudeWebPlugin = {
  name: "Logger",
  type: "before",

  execute: async event => {
    log(event.event_type, event)

    return event
  },
}
